"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RANKABLE_ITEMS = void 0;
exports.RANKABLE_ITEMS = 'rankableItems';
